// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"14":"ec39acac","835":"ca37faa7"}[chunkId] + ".chunk.css";
};